import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-common/models/tas-application';

export default class AuthenticatedTasApplicationsHistoryRoute extends Route {
  @service declare store: StoreService;

  includes = ['tas-courses', 'tas-program-instance.tas-program-template'];

  async model({
    tas_application_id,
  }: {
    tas_application_id: string;
  }): Promise<TasApplicationModel> {
    const application = await this.store.findRecord<TasApplicationModel>(
      'tas-application',
      tas_application_id,
      {
        include: this.includes.join(','),
        reload: true,
      }
    );
    await application.loadHistory();
    return application;
  }
}
